import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Badge from '../../../../../../../components/global/Badge';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  badgeText: PropTypes.string,
};

const SecondaryControlButtonSizeRectangle = ({
  className,
  width,
  height,
  badgeText,
}) => {
  const classes = classNames({
    'print-product-configurator-controls-secondary-btn-rectangle': true,
    'with-badge': !!badgeText,
    [className]: !!className,
  });

  // 8x10
  // should be 80% width, 100% height.
  // How?

  const isLandscape = width >= height;
  // 10 / 8 = 1.25
  const baseRatio = isLandscape ? width / height : height / width;
  // 1
  const actualRatio = Math.min(1, baseRatio);
  const actualWidth = isLandscape
    ? actualRatio
    : (actualRatio * width) / height;
  const actualHeight = !isLandscape
    ? actualRatio
    : (actualRatio * height) / width;

  return (
    <div
      className={classes}
      style={{
        width: `${actualWidth * 100}%`,
        height: `${actualHeight * 100}%`,
      }}
    >
      {!!badgeText && (
        <Badge badgeSize="xs" badgeStyle="info">
          {badgeText}
        </Badge>
      )}
    </div>
  );
};

SecondaryControlButtonSizeRectangle.propTypes = propTypes;

export default SecondaryControlButtonSizeRectangle;
